export const DASHBOARD_CONSTANTS = {
  CARD_FOOTER_BUTTON: "Add New",
  DASHBOARD_CARD_TITLE_ONE: "DSO/Private Office",
  DASHBOARD_CARD_TITLE_TWO: "Dental Professional",
  DASHBOARD_CARD_TITLE_THREE: "Jobs",
  DENTAL_PROFESSIONAL:
    "View, Add, Edit, Approve, Reject,Offer Letter etc. for Dental Professional accounts",
  JOBS: "View,Approve, Reject,List Request and Assign applicants sent offer letter Edit Jobs before publishing etc",
  PRIVATE_OFFICE:
    "View, Add, Edit, Approve, Reject, Enable/Disable DSO/Private Office Accounts etc. reset passwords",
};

export const MODAL_TEXT_CONSTANTS = {
  CANCEL_BUTTON: "Cancel",
  CONFIRM_BUTTON: "Confirm",
  MODAL_LOGOUT: "Are you sure you want to logout ?",
};

export const NAVBAR_CONSTANTS = {
  LOGOUT_BUTTON: "Logout",
  NAVBAR_HEADING: "Dental Dynamic Staffing",
};
